var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return !_vm.isLoading &&
    _vm.$store.getters.isLoggedIn &&
    _vm.orgRoleIsPermitted(_vm.$orgRoles.CUSTOMER_FL44)
    ? _c(
        "div",
        {
          staticClass: "purchases_create atmo-page atmo-hash-jump-point",
          attrs: { id: "atmo-top" },
        },
        [
          _vm._m(0),
          _c("purchase-header-block", {
            attrs: {
              organization: _vm.customer,
              title: _vm.isModeEdit
                ? `Редактирование извещения № ${_vm.form.reg_number} 44-ФЗ`
                : "Объявление о закупочной сессии 44-ФЗ",
            },
          }),
          _c(
            "b-container",
            {
              staticClass: "my-4 position-relative purchase_session",
              staticStyle: { "background-color": "#f5f5f7" },
            },
            [
              _c("online-course-regular-button", { staticClass: "mb-3" }),
              _vm.isModeEdit
                ? _c("fl44-approvals-history-block", {
                    attrs: { "approvals-history": _vm.approvalsHistory },
                  })
                : _vm._e(),
              _c("form-row-edit-text", {
                attrs: { label: "Дополнительная контактная информация" },
                model: {
                  value: _vm.form.purchase_terms.contact_info,
                  callback: function ($$v) {
                    _vm.$set(_vm.form.purchase_terms, "contact_info", $$v)
                  },
                  expression: "form.purchase_terms.contact_info",
                },
              }),
              _c("form-row-edit-textarea", {
                attrs: {
                  rows: 5,
                  label:
                    "Примечание к закупке (отображается только в ЛК Заказчика)",
                },
                model: {
                  value: _vm.form.purchase_terms.comment,
                  callback: function ($$v) {
                    _vm.$set(_vm.form.purchase_terms, "comment", $$v)
                  },
                  expression: "form.purchase_terms.comment",
                },
              }),
              _c(
                "h2",
                {
                  staticClass: "atmo-hash-jump-point font-weight-bold",
                  attrs: { id: "purchase-terms" },
                },
                [_vm._v("Условия закупки")]
              ),
              _c("form-row-single-select", {
                attrs: {
                  disabled:
                    _vm.restrictions.was_canceled &&
                    _vm.form.purchase_terms.deliverable_group_id &&
                    !_vm.$v.form.purchase_terms.deliverable_group_id.$anyDirty,
                  options: _vm.dictionaries.deliverable_groups,
                  v: _vm.$v.form.purchase_terms.deliverable_group_id,
                  label: "Предмет закупки",
                  placeholder: "Выберите предмет закупки",
                },
                model: {
                  value: _vm.form.purchase_terms.deliverable_group_id,
                  callback: function ($$v) {
                    _vm.$set(
                      _vm.form.purchase_terms,
                      "deliverable_group_id",
                      $$v
                    )
                  },
                  expression: "form.purchase_terms.deliverable_group_id",
                },
              }),
              _c("form-row-edit-text", {
                attrs: {
                  label: "Объект закупки",
                  hint: "Укажите непосредственно товары, работы, услуги, поставка, выполнение, оказание которых будут являться предметом контракта.",
                  v: _vm.$v.form.purchase_terms.purchase_object,
                },
                model: {
                  value: _vm.form.purchase_terms.purchase_object,
                  callback: function ($$v) {
                    _vm.$set(_vm.form.purchase_terms, "purchase_object", $$v)
                  },
                  expression: "form.purchase_terms.purchase_object",
                },
              }),
              _c("form-row-single-select", {
                attrs: {
                  options: _vm.$globalDictionaries.orderTypes.filter(
                    (item) => item.is_fl44
                  ),
                  v: _vm.$v.form.purchase_terms.order_type_id,
                  label: "Тип закупки",
                  "label-field": "title",
                  placeholder: "Выберите тип закупки",
                },
                on: {
                  input: function ($event) {
                    _vm.form.limits.items = []
                  },
                },
                model: {
                  value: _vm.form.purchase_terms.order_type_id,
                  callback: function ($$v) {
                    _vm.$set(_vm.form.purchase_terms, "order_type_id", $$v)
                  },
                  expression: "form.purchase_terms.order_type_id",
                },
              }),
              _c("form-row-single-select", {
                attrs: {
                  disabled: _vm.restrictions.was_canceled,
                  options: _vm.$globalDictionaries.fl44PurchaseDurationTypes,
                  v: _vm.$v.form.purchase_terms.duration_type,
                  label: "Продолжительность закупочной сессии",
                  placeholder: "Выберите продолжительность закупочной сессии",
                },
                model: {
                  value: _vm.form.purchase_terms.duration_type,
                  callback: function ($$v) {
                    _vm.$set(_vm.form.purchase_terms, "duration_type", $$v)
                  },
                  expression: "form.purchase_terms.duration_type",
                },
              }),
              _vm.form.purchase_terms.duration_type === "fast"
                ? [
                    _c("form-row-single-select", {
                      attrs: {
                        options: _vm.dictionaries.urgency_reasons,
                        v: _vm.$v.form.purchase_terms
                          .fast_purchase_justification,
                        "label-field": "title",
                        label: "Причина проведения срочной закупочной сессии",
                        "track-by": "title",
                        placeholder:
                          "Выберите причину проведения срочной закупочной сессии",
                      },
                      model: {
                        value:
                          _vm.form.purchase_terms.fast_purchase_justification,
                        callback: function ($$v) {
                          _vm.$set(
                            _vm.form.purchase_terms,
                            "fast_purchase_justification",
                            $$v
                          )
                        },
                        expression:
                          "form.purchase_terms.fast_purchase_justification",
                      },
                    }),
                    _c("form-row-single-line-document-upload", {
                      attrs: {
                        "label-cols-lg": 3,
                        v: _vm.$v.form.purchase_terms
                          .fast_purchase_justification_attachment,
                        title:
                          "Документ обоснования проведения срочной закупочной сессии",
                      },
                      model: {
                        value:
                          _vm.form.purchase_terms
                            .fast_purchase_justification_attachment,
                        callback: function ($$v) {
                          _vm.$set(
                            _vm.form.purchase_terms,
                            "fast_purchase_justification_attachment",
                            $$v
                          )
                        },
                        expression:
                          "form.purchase_terms.fast_purchase_justification_attachment",
                      },
                    }),
                  ]
                : _vm._e(),
              _vm.withoutLimits
                ? _c("form-row-edit-checkbox", {
                    attrs: {
                      label: "Закупка при отсутствии ЛБО (лимитов по КБК)",
                    },
                    model: {
                      value: _vm.form.purchase_terms.without_limits,
                      callback: function ($$v) {
                        _vm.$set(_vm.form.purchase_terms, "without_limits", $$v)
                      },
                      expression: "form.purchase_terms.without_limits",
                    },
                  })
                : _vm._e(),
              !_vm.form.purchase_terms.without_limits
                ? _c("form-row-single-select", {
                    attrs: {
                      v: _vm.$v.form.purchase_terms.purchase_limit_year,
                      options: _vm.dictionaries.limitYears,
                      label: "Год ПГ (Плана-графика)",
                      "label-field": "id",
                      placeholder: "Выберите год ПГ (Плана-графика)",
                    },
                    on: {
                      input: function ($event) {
                        _vm.form.limits.items = []
                      },
                    },
                    model: {
                      value: _vm.form.purchase_terms.purchase_limit_year,
                      callback: function ($$v) {
                        _vm.$set(
                          _vm.form.purchase_terms,
                          "purchase_limit_year",
                          $$v
                        )
                      },
                      expression: "form.purchase_terms.purchase_limit_year",
                    },
                  })
                : _vm._e(),
              _c("form-row-edit-checkbox", {
                attrs: { label: "Аванс" },
                model: {
                  value: _vm.form.purchase_terms.with_advance,
                  callback: function ($$v) {
                    _vm.$set(_vm.form.purchase_terms, "with_advance", $$v)
                  },
                  expression: "form.purchase_terms.with_advance",
                },
              }),
              _vm.form.purchase_terms.with_advance
                ? _c("form-row-edit-number", {
                    attrs: {
                      label: "Размер аванса, %",
                      "max-value": 30,
                      "min-value": 1,
                      v: _vm.$v.form.purchase_terms.advance_percentage,
                    },
                    model: {
                      value: _vm.form.purchase_terms.advance_percentage,
                      callback: function ($$v) {
                        _vm.$set(
                          _vm.form.purchase_terms,
                          "advance_percentage",
                          $$v
                        )
                      },
                      expression: "form.purchase_terms.advance_percentage",
                    },
                  })
                : _vm._e(),
              _c("form-row-edit-date", {
                attrs: {
                  "min-date": _vm.moment().format("YYYY-MM-DD"),
                  v: _vm.$v.form.purchase_terms
                    .planned_contract_conclusion_date,
                  label: "Планируемая дата заключения контракта",
                  hint: "Не может быть меньше текущей даты.",
                },
                on: { input: _vm.onDateInput },
                model: {
                  value:
                    _vm.form.purchase_terms.planned_contract_conclusion_date,
                  callback: function ($$v) {
                    _vm.$set(
                      _vm.form.purchase_terms,
                      "planned_contract_conclusion_date",
                      $$v
                    )
                  },
                  expression:
                    "form.purchase_terms.planned_contract_conclusion_date",
                },
              }),
              _c("form-row-edit-date", {
                attrs: {
                  disabled:
                    !_vm.form.purchase_terms.planned_contract_conclusion_date,
                  "min-date":
                    _vm.form.purchase_terms.planned_contract_conclusion_date,
                  v: _vm.$v.form.purchase_terms.planned_contract_execution_date,
                  label: "Планируемая дата исполнения контракта",
                  hint: "Дату можно выбрать только после выбора Планируемой даты заключения контракта.",
                },
                model: {
                  value:
                    _vm.form.purchase_terms.planned_contract_execution_date,
                  callback: function ($$v) {
                    _vm.$set(
                      _vm.form.purchase_terms,
                      "planned_contract_execution_date",
                      $$v
                    )
                  },
                  expression:
                    "form.purchase_terms.planned_contract_execution_date",
                },
              }),
              _c("form-row-edit-textarea", {
                attrs: {
                  v: _vm.$v.form.purchase_terms
                    .unilateral_contract_termination_info,
                  rows: 4,
                  label:
                    "Информация о возможности и случаях одностороннего расторжения сделки в соответствии с действующим законодательством Российской Федерации",
                },
                model: {
                  value:
                    _vm.form.purchase_terms
                      .unilateral_contract_termination_info,
                  callback: function ($$v) {
                    _vm.$set(
                      _vm.form.purchase_terms,
                      "unilateral_contract_termination_info",
                      $$v
                    )
                  },
                  expression:
                    "form.purchase_terms.unilateral_contract_termination_info",
                },
              }),
              _c(
                "h2",
                {
                  staticClass: "atmo-hash-jump-point font-weight-bold",
                  attrs: { id: "supplier-requirements" },
                },
                [_vm._v("Требования к участникам закупки")]
              ),
              _c("form-row-edit-checkbox", {
                attrs: {
                  "label-cols-sm": 11,
                  "label-cols-lg": 11,
                  "form-class": "text-right",
                  v: _vm.$v.form.supplier_requirements.only_smp,
                  label:
                    "Участником закупки могут быть только субъекты малого предпринимательства (СМП)",
                  compact: "",
                },
                model: {
                  value: _vm.form.supplier_requirements.only_smp,
                  callback: function ($$v) {
                    _vm.$set(_vm.form.supplier_requirements, "only_smp", $$v)
                  },
                  expression: "form.supplier_requirements.only_smp",
                },
              }),
              _c("form-row-edit-checkbox", {
                attrs: {
                  "label-cols-sm": 11,
                  "label-cols-lg": 11,
                  "form-class": "text-right",
                  v: _vm.$v.form.supplier_requirements.supplier_reqs_rating,
                  label:
                    "Установить требование к участникам по рейтингу с возможностью отклонения предложения участника с рейтингом ниже 4,5 балла",
                  compact: "",
                },
                model: {
                  value: _vm.form.supplier_requirements.supplier_reqs_rating,
                  callback: function ($$v) {
                    _vm.$set(
                      _vm.form.supplier_requirements,
                      "supplier_reqs_rating",
                      $$v
                    )
                  },
                  expression: "form.supplier_requirements.supplier_reqs_rating",
                },
              }),
              _c("form-row-edit-checkbox", {
                attrs: {
                  "label-cols-sm": 11,
                  "label-cols-lg": 11,
                  "form-class": "text-right",
                  v: _vm.$v.form.supplier_requirements.supplier_reqs_a,
                  label:
                    "Соответствие участника закупки требованиям п.1 ч.1 ст.31 Федерального закона «О контрактной системе в сфере закупок товаров, работ, услуг для обеспечения государственных и муниципальных нужд» от 05.04.2013 №44-ФЗ",
                  compact: "",
                },
                on: { input: _vm.clearSupplierReqsA },
                model: {
                  value: _vm.form.supplier_requirements.supplier_reqs_a,
                  callback: function ($$v) {
                    _vm.$set(
                      _vm.form.supplier_requirements,
                      "supplier_reqs_a",
                      $$v
                    )
                  },
                  expression: "form.supplier_requirements.supplier_reqs_a",
                },
              }),
              _vm.form.supplier_requirements.supplier_reqs_a
                ? _c("supplier-requirement-supplier-reqs-a-edit-table", {
                    attrs: {
                      v: _vm.$v.form.supplier_requirements
                        .supplier_reqs_a_details,
                    },
                    model: {
                      value:
                        _vm.form.supplier_requirements.supplier_reqs_a_details,
                      callback: function ($$v) {
                        _vm.$set(
                          _vm.form.supplier_requirements,
                          "supplier_reqs_a_details",
                          $$v
                        )
                      },
                      expression:
                        "form.supplier_requirements.supplier_reqs_a_details",
                    },
                  })
                : _vm._e(),
              _c("form-row-edit-checkbox", {
                attrs: {
                  "label-cols-sm": 11,
                  "label-cols-lg": 11,
                  "form-class": "text-right",
                  v: _vm.$v.form.supplier_requirements.supplier_reqs_b,
                  label:
                    "Соответствие участника закупки требованиям п.3-5, 7-11 ч.1 ст.31 Федерального закона «О контрактной системе в сфере закупок товаров, работ, услуг для обеспечения государственных и муниципальных нужд» от 05.04.2013 №44-ФЗ (обязательно)",
                  disabled: "",
                  compact: "",
                },
                model: {
                  value: _vm.form.supplier_requirements.supplier_reqs_b,
                  callback: function ($$v) {
                    _vm.$set(
                      _vm.form.supplier_requirements,
                      "supplier_reqs_b",
                      $$v
                    )
                  },
                  expression: "form.supplier_requirements.supplier_reqs_b",
                },
              }),
              _c("form-row-edit-checkbox", {
                attrs: {
                  "label-cols-sm": 11,
                  "label-cols-lg": 11,
                  "form-class": "text-right",
                  v: _vm.$v.form.supplier_requirements.supplier_reqs_c,
                  label:
                    "Соответствие участника закупки требованиям ч.1.1 ст.31 Федерального закона «О контрактной системе в сфере закупок товаров, работ, услуг для обеспечения государственных и муниципальных нужд» от 05.04.2013 №44-ФЗ",
                  compact: "",
                },
                model: {
                  value: _vm.form.supplier_requirements.supplier_reqs_c,
                  callback: function ($$v) {
                    _vm.$set(
                      _vm.form.supplier_requirements,
                      "supplier_reqs_c",
                      $$v
                    )
                  },
                  expression: "form.supplier_requirements.supplier_reqs_c",
                },
              }),
              _c("form-row-edit-checkbox", {
                attrs: {
                  "label-cols-sm": 11,
                  "label-cols-lg": 11,
                  "form-class": "text-right",
                  v: _vm.$v.form.supplier_requirements.supplier_reqs_sonko,
                  label:
                    "Участник является социально ориентированной некоммерческой организацией (СОНКО)",
                  compact: "",
                },
                model: {
                  value: _vm.form.supplier_requirements.supplier_reqs_sonko,
                  callback: function ($$v) {
                    _vm.$set(
                      _vm.form.supplier_requirements,
                      "supplier_reqs_sonko",
                      $$v
                    )
                  },
                  expression: "form.supplier_requirements.supplier_reqs_sonko",
                },
              }),
              _c("form-row-edit-checkbox", {
                attrs: {
                  "label-cols-sm": 11,
                  "label-cols-lg": 11,
                  "form-class": "text-right",
                  v: _vm.$v.form.supplier_requirements
                    .has_additional_requirements,
                  label: "Дополнительные требования к участникам закупки",
                  compact:
                    _vm.form.supplier_requirements.has_additional_requirements,
                },
                on: { input: _vm.clearAdditionalRequirements },
                model: {
                  value:
                    _vm.form.supplier_requirements.has_additional_requirements,
                  callback: function ($$v) {
                    _vm.$set(
                      _vm.form.supplier_requirements,
                      "has_additional_requirements",
                      $$v
                    )
                  },
                  expression:
                    "form.supplier_requirements.has_additional_requirements",
                },
              }),
              _vm.form.supplier_requirements.has_additional_requirements
                ? _c("additional-supplier-requirements-edit-table", {
                    attrs: {
                      v: _vm.$v.form.supplier_requirements
                        .additional_requirements,
                    },
                    model: {
                      value:
                        _vm.form.supplier_requirements.additional_requirements,
                      callback: function ($$v) {
                        _vm.$set(
                          _vm.form.supplier_requirements,
                          "additional_requirements",
                          $$v
                        )
                      },
                      expression:
                        "form.supplier_requirements.additional_requirements",
                    },
                  })
                : _vm._e(),
              _c(
                "h2",
                {
                  staticClass: "atmo-hash-jump-point font-weight-bold",
                  attrs: { id: "supply-terms" },
                },
                [_vm._v("Условия поставки")]
              ),
              _c("form-row-edit-addresses-new", {
                attrs: {
                  value: _vm.form.delivery_terms.addresses,
                  label: "Адрес для доставки/самовывоза",
                  hint: "Укажите новый адрес или выберите ранее сохраненный адрес из Адресной книги.",
                  compact: "",
                },
                on: {
                  "update:value": function ($event) {
                    return _vm.$set(
                      _vm.form.delivery_terms,
                      "addresses",
                      $event
                    )
                  },
                },
              }),
              _c("form-row-edit-textarea", {
                attrs: {
                  rows: 4,
                  label:
                    "График поставки товаров (выполнения работ, оказания услуг)",
                },
                model: {
                  value: _vm.form.delivery_terms.schedule,
                  callback: function ($$v) {
                    _vm.$set(_vm.form.delivery_terms, "schedule", $$v)
                  },
                  expression: "form.delivery_terms.schedule",
                },
              }),
              _c("form-row-specification-table-new", {
                staticClass: "atmo-hash-jump-point",
                attrs: {
                  id: "specification",
                  "spec-error-message": _vm.specErrorMessage,
                  "spec-errors": _vm.specErrors,
                  "spec-sum": _vm.specSum,
                  v: _vm.$v.form.deliverables,
                  "with-count-edit": "",
                  "with-price": "",
                },
                model: {
                  value: _vm.form.deliverables,
                  callback: function ($$v) {
                    _vm.$set(_vm.form, "deliverables", $$v)
                  },
                  expression: "form.deliverables",
                },
              }),
              _vm.features.kbk_limits && !_vm.form.purchase_terms.without_limits
                ? _c("limits-editable-table", {
                    attrs: {
                      "total-cost": _vm.specSum,
                      "limit-year": _vm.form.purchase_terms.purchase_limit_year,
                      "order-type": _vm.currentOrderType,
                      "purchase-type": "fl44",
                      "purchase-id": _vm.purchaseId,
                    },
                    on: { validate: _vm.limitsValidate },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "info",
                          fn: function () {
                            return [
                              _c(
                                "p",
                                { staticClass: "fs-14" },
                                [
                                  _c("b-icon-exclamation-triangle-fill", {
                                    staticClass: "text-warning",
                                  }),
                                  _vm._v(
                                    ' Внимание! Перед добавлением лимитов проверьте правильность значений полей "Год ПГ" и "Тип закупки" в разделе "Информация о закупке". При изменении любого из этих полей все добавленные в таблицу лимиты по КБК будут удалены. '
                                  ),
                                ],
                                1
                              ),
                            ]
                          },
                          proxy: true,
                        },
                      ],
                      null,
                      false,
                      2636696083
                    ),
                    model: {
                      value: _vm.form.limits.items,
                      callback: function ($$v) {
                        _vm.$set(_vm.form.limits, "items", $$v)
                      },
                      expression: "form.limits.items",
                    },
                  })
                : _vm._e(),
              _c(
                "h2",
                {
                  staticClass: "atmo-hash-jump-point font-weight-bold",
                  attrs: { id: "documents" },
                },
                [_vm._v("Документы")]
              ),
              _c("form-row-single-line-document-upload", {
                attrs: {
                  "label-cols-lg": 3,
                  v: _vm.$v.form.purchase_terms.contract_draft_attachment,
                  title: "Проект ГК",
                },
                model: {
                  value: _vm.form.purchase_terms.contract_draft_attachment,
                  callback: function ($$v) {
                    _vm.$set(
                      _vm.form.purchase_terms,
                      "contract_draft_attachment",
                      $$v
                    )
                  },
                  expression: "form.purchase_terms.contract_draft_attachment",
                },
              }),
              _c("form-row-single-line-multiple-documents-upload", {
                attrs: {
                  "label-cols-lg": 3,
                  title: "Дополнительные документы",
                  v: _vm.$v.form.additional_documents,
                },
                model: {
                  value: _vm.form.additional_documents,
                  callback: function ($$v) {
                    _vm.$set(_vm.form, "additional_documents", $$v)
                  },
                  expression: "form.additional_documents",
                },
              }),
              _c(
                "b-row",
                { staticClass: "my-3 mt-5" },
                [
                  _c(
                    "b-col",
                    [
                      _c(
                        "b-button",
                        {
                          staticClass: "mr-1 mb-1 text-uppercase",
                          attrs: { variant: "custom-outline-secondary" },
                          on: { click: _vm.onCancel },
                        },
                        [_vm._v("Отменить")]
                      ),
                      _c(
                        "b-button",
                        {
                          staticClass: "text-uppercase mr-1 mb-1",
                          attrs: { variant: "custom-danger" },
                          on: { click: _vm.saveDraft },
                        },
                        [_vm._v("Сохранить черновик")]
                      ),
                      _c(
                        "b-button",
                        {
                          staticClass: "text-uppercase mr-1 mb-1",
                          attrs: {
                            disabled:
                              !_vm.isValid || !_vm.$store.getters.getCanSign,
                            variant: "custom-green",
                          },
                          on: { click: _vm.validateForm },
                        },
                        [_vm._v("Подписать и сохранить")]
                      ),
                      !_vm.$store.getters.getCanSign
                        ? [
                            _vm.$store.getters.getLoginType === "cert"
                              ? _c(
                                  "span",
                                  {
                                    staticClass:
                                      "text-danger pl-3 pt-0 fs-14 w-50 my-auto",
                                  },
                                  [
                                    _vm._v(
                                      "Для действия требуется загрузить/заменить МЧД на странице: "
                                    ),
                                    _c(
                                      "router-link",
                                      {
                                        staticClass: "green-link",
                                        attrs: {
                                          to: { name: "CabinetUserProfile" },
                                        },
                                      },
                                      [_vm._v("Данные учетной записи")]
                                    ),
                                  ],
                                  1
                                )
                              : _c(
                                  "span",
                                  {
                                    staticClass:
                                      "text-danger pl-3 pt-0 fs-14 w-50 my-auto",
                                  },
                                  [
                                    _vm._v(
                                      "Подписание возможно только при авторизации при помощи ЭЦП"
                                    ),
                                  ]
                                ),
                          ]
                        : _vm._e(),
                    ],
                    2
                  ),
                ],
                1
              ),
              _c(
                "b-modal",
                {
                  ref: "sign-form-modal",
                  attrs: {
                    centered: "",
                    "no-close-on-backdrop": "",
                    "no-close-on-esc": "",
                    scrollable: "",
                    size: "lg",
                    title: "Подписать извещение",
                  },
                  on: { close: _vm.cancelSignModal },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "modal-header-close",
                        fn: function () {
                          return [_c("button-close-modal")]
                        },
                        proxy: true,
                      },
                    ],
                    null,
                    false,
                    1489420097
                  ),
                  model: {
                    value: _vm.showSignModal,
                    callback: function ($$v) {
                      _vm.showSignModal = $$v
                    },
                    expression: "showSignModal",
                  },
                },
                [
                  _c(
                    "div",
                    { staticClass: "d-block text-left" },
                    [
                      _c(
                        "b-tabs",
                        { attrs: { "content-class": "mt-3 px-3" } },
                        [
                          _c(
                            "b-tab",
                            {
                              attrs: { active: "" },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "title",
                                    fn: function () {
                                      return [
                                        _c(
                                          "span",
                                          {
                                            staticClass:
                                              "system_link-style fs-16",
                                          },
                                          [_vm._v("Форма")]
                                        ),
                                      ]
                                    },
                                    proxy: true,
                                  },
                                ],
                                null,
                                false,
                                2602645129
                              ),
                            },
                            [
                              _c("h4", { staticClass: "font-weight-bold" }, [
                                _vm._v("Информация о заказчике"),
                              ]),
                              _c("text-row", {
                                attrs: {
                                  compact: "",
                                  label: "Наименование организации",
                                  value: _vm.customer.name,
                                },
                              }),
                              _c("text-row", {
                                attrs: {
                                  compact: "",
                                  label: "ИНН",
                                  value: _vm.customer.inn,
                                },
                              }),
                              _c("text-row", {
                                attrs: {
                                  compact: "",
                                  label: "КПП",
                                  value: _vm.customer.kpp,
                                },
                              }),
                              _c("text-row", {
                                attrs: {
                                  compact: "",
                                  label: "ОГРН",
                                  value: _vm.customer.ogrn,
                                },
                              }),
                              _c("text-row", {
                                attrs: {
                                  compact: "",
                                  label: "Адрес",
                                  value: _vm.customer.legal_address,
                                },
                              }),
                              _c("text-row", {
                                attrs: {
                                  compact: "",
                                  label: "Дополнительная контактная информация",
                                  value: _vm.form.purchase_terms.contact_info,
                                },
                              }),
                              _c("hr"),
                              _c("h4", { staticClass: "font-weight-bold" }, [
                                _vm._v("Условия закупки"),
                              ]),
                              _c("text-row", {
                                attrs: {
                                  compact: "",
                                  "label-cols-lg": 4,
                                  "label-cols-sm": 4,
                                  label: "Объект закупки",
                                  value:
                                    _vm.form.purchase_terms.purchase_object,
                                },
                              }),
                              _c("text-row", {
                                attrs: {
                                  compact: "",
                                  "label-cols-lg": 4,
                                  "label-cols-sm": 4,
                                  label: "Предмет закупки",
                                  value:
                                    _vm.dictionaries.deliverable_groups?.find(
                                      (item) =>
                                        item.id ===
                                        _vm.form.purchase_terms
                                          .deliverable_group_id
                                    )?.name,
                                },
                              }),
                              _c("text-row", {
                                attrs: {
                                  compact: "",
                                  "label-cols-lg": 4,
                                  "label-cols-sm": 4,
                                  label: "Тип закупки",
                                  value: _vm.currentOrderType?.title,
                                },
                              }),
                              _c("text-row", {
                                attrs: {
                                  compact: "",
                                  "label-cols-lg": 4,
                                  "label-cols-sm": 4,
                                  label: "Тип закупочной сессии",
                                  value: _vm.currentDurationType?.name,
                                },
                              }),
                              _vm.form.purchase_terms.duration_type === "fast"
                                ? [
                                    _c("text-row", {
                                      attrs: {
                                        compact: "",
                                        "label-cols-lg": 4,
                                        "label-cols-sm": 4,
                                        label:
                                          "Причина проведения срочной закупочной сессии",
                                        value:
                                          _vm.form.purchase_terms
                                            .fast_purchase_justification,
                                      },
                                    }),
                                    _c("text-row-single-document", {
                                      attrs: {
                                        compact: "",
                                        "label-cols-lg": 4,
                                        "label-cols-sm": 4,
                                        label:
                                          "Документ обоснования проведения срочной закупочной сессии",
                                        value:
                                          _vm.form.purchase_terms
                                            .fast_purchase_justification_attachment,
                                      },
                                    }),
                                  ]
                                : _vm._e(),
                              _c("text-row-boolean-text", {
                                attrs: {
                                  compact: "",
                                  "label-cols-lg": 4,
                                  "label-cols-sm": 4,
                                  label: "Аванс",
                                  value: _vm.form.purchase_terms.with_advance,
                                },
                              }),
                              _vm.form.purchase_terms.with_advance
                                ? _c("text-row", {
                                    attrs: {
                                      compact: "",
                                      "label-cols-lg": 4,
                                      "label-cols-sm": 4,
                                      label: "Размер аванса",
                                      value:
                                        _vm.form.purchase_terms
                                          .advance_percentage + "%",
                                    },
                                  })
                                : _vm._e(),
                              _c("text-row-date", {
                                attrs: {
                                  compact: "",
                                  "label-cols-lg": 4,
                                  "label-cols-sm": 4,
                                  label: "Планируемая дата заключения договора",
                                  value:
                                    _vm.form.purchase_terms
                                      .planned_contract_conclusion_date,
                                },
                              }),
                              _c("text-row-date", {
                                attrs: {
                                  compact: "",
                                  "label-cols-lg": 4,
                                  "label-cols-sm": 4,
                                  label: "Планируемая дата исполнения договора",
                                  value:
                                    _vm.form.purchase_terms
                                      .planned_contract_execution_date,
                                },
                              }),
                              _c("text-row-single-document", {
                                attrs: {
                                  compact: "",
                                  "label-cols-lg": 4,
                                  "label-cols-sm": 4,
                                  label: "Проект ГК",
                                  value:
                                    _vm.form.purchase_terms
                                      .contract_draft_attachment,
                                },
                              }),
                              _c("text-row-price", {
                                attrs: {
                                  compact: "",
                                  "label-cols-lg": 4,
                                  "label-cols-sm": 4,
                                  label: "Сумма закупки",
                                  value: _vm.specSum,
                                },
                              }),
                              _c("text-row", {
                                attrs: {
                                  compact: "",
                                  "label-cols-lg": 4,
                                  "label-cols-sm": 4,
                                  label:
                                    "Информация о возможности и случаях одностороннего расторжения сделки в соответствии с действующим законодательством Российской Федерации",
                                  value:
                                    _vm.form.purchase_terms
                                      .unilateral_contract_termination_info,
                                  "text-wrap": "",
                                },
                              }),
                              _c("hr"),
                              _c("h4", { staticClass: "font-weight-bold" }, [
                                _vm._v("Требования к участникам закупки"),
                              ]),
                              _c("text-row-boolean-text", {
                                attrs: {
                                  compact: "",
                                  "label-cols-lg": 11,
                                  "label-cols-sm": 11,
                                  label:
                                    "Участником закупки могут быть только субъекты малого предпринимательства (СМП)",
                                  value:
                                    _vm.form.supplier_requirements.only_smp,
                                  "value-class": "text-right",
                                },
                              }),
                              _c("text-row-boolean-text", {
                                attrs: {
                                  compact: "",
                                  "label-cols-lg": 11,
                                  "label-cols-sm": 11,
                                  label:
                                    "Установить требование к участникам по рейтингу с возможностью отклонения предложения участника с рейтингом ниже 4,5 балла",
                                  value:
                                    _vm.form.supplier_requirements
                                      .supplier_reqs_rating,
                                  "value-class": "text-right",
                                },
                              }),
                              _c("text-row-boolean-text", {
                                attrs: {
                                  compact: "",
                                  "label-cols-lg": 11,
                                  "label-cols-sm": 11,
                                  label:
                                    "Соответствие участника закупки требованиям п.1 ч.1 ст.31 Федерального закона «О контрактной системе в сфере закупок товаров, работ, услуг для обеспечения государственных и муниципальных нужд» от 05.04.2013 №44-ФЗ",
                                  value:
                                    _vm.form.supplier_requirements
                                      .supplier_reqs_a,
                                  "value-class": "text-right",
                                },
                              }),
                              _vm.form.supplier_requirements.supplier_reqs_a
                                ? _c(
                                    "b-container",
                                    [
                                      _c("text-row", {
                                        attrs: {
                                          compact: "",
                                          "label-cols-lg": 4,
                                          "label-cols-sm": 4,
                                          label: "Описание требований",
                                          value:
                                            _vm.form.supplier_requirements
                                              .supplier_reqs_a_details
                                              .supplier_reqs_a_text,
                                          "text-wrap": "",
                                        },
                                      }),
                                      _c(
                                        "b-form-group",
                                        {
                                          staticClass: "mb-0",
                                          attrs: {
                                            "label-cols-sm": 4,
                                            "label-cols-lg": 4,
                                            label: "Подтверждающие документы:",
                                            "label-class":
                                              "fs-14 grey-color fw-700 d-flex align-items-baseline",
                                          },
                                        },
                                        [
                                          _c(
                                            "ul",
                                            _vm._l(
                                              _vm.form.supplier_requirements
                                                .supplier_reqs_a_details
                                                .supplier_reqs_a_documents,
                                              function (item, index) {
                                                return _c(
                                                  "li",
                                                  {
                                                    key: index,
                                                    staticClass:
                                                      "fs-14 grey-color my-auto col-form-label pb-0",
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        index +
                                                          1 +
                                                          ". " +
                                                          item.description
                                                      )
                                                    ),
                                                  ]
                                                )
                                              }
                                            ),
                                            0
                                          ),
                                        ]
                                      ),
                                    ],
                                    1
                                  )
                                : _vm._e(),
                              _c("text-row-boolean-text", {
                                attrs: {
                                  compact: "",
                                  "label-cols-lg": 11,
                                  "label-cols-sm": 11,
                                  label:
                                    "Соответствие участника закупки требованиям п.3-5, 7-11 ч.1 ст.31 Федерального закона «О контрактной системе в сфере закупок товаров, работ, услуг для обеспечения государственных и муниципальных нужд» от 05.04.2013 №44-ФЗ",
                                  value:
                                    _vm.form.supplier_requirements
                                      .supplier_reqs_b,
                                  "value-class": "text-right",
                                },
                              }),
                              _c("text-row-boolean-text", {
                                attrs: {
                                  compact: "",
                                  "label-cols-lg": 11,
                                  "label-cols-sm": 11,
                                  label:
                                    "Соответствие участника закупки требованиям ч.1.1 ст.31 Федерального закона «О контрактной системе в сфере закупок товаров, работ, услуг для обеспечения государственных и муниципальных нужд» от 05.04.2013 №44-ФЗ",
                                  value:
                                    _vm.form.supplier_requirements
                                      .supplier_reqs_c,
                                  "value-class": "text-right",
                                },
                              }),
                              _c("text-row-boolean-text", {
                                attrs: {
                                  compact: "",
                                  "label-cols-lg": 11,
                                  "label-cols-sm": 11,
                                  label:
                                    "Участник является социально ориентированной некоммерческой организацией (СОНКО)",
                                  value:
                                    _vm.form.supplier_requirements
                                      .supplier_reqs_sonko,
                                  "value-class": "text-right",
                                },
                              }),
                              _c("text-row-boolean-text", {
                                attrs: {
                                  compact: "",
                                  "label-cols-lg": 11,
                                  "label-cols-sm": 11,
                                  label:
                                    "Дополнительные требования к участникам закупки",
                                  value:
                                    _vm.form.supplier_requirements
                                      .has_additional_requirements,
                                  "value-class": "text-right",
                                },
                              }),
                              _c(
                                "div",
                                {
                                  directives: [
                                    {
                                      name: "show",
                                      rawName: "v-show",
                                      value:
                                        _vm.form.supplier_requirements
                                          .has_additional_requirements,
                                      expression:
                                        "form.supplier_requirements.has_additional_requirements",
                                    },
                                  ],
                                },
                                [
                                  _c(
                                    "section",
                                    { staticStyle: { width: "100%" } },
                                    [
                                      _c(
                                        "div",
                                        { staticClass: "table-responsive" },
                                        [
                                          _c(
                                            "table",
                                            {
                                              staticClass:
                                                "atmo-content-table mb-0",
                                            },
                                            [
                                              _c("thead", [
                                                _c("tr", [
                                                  _c(
                                                    "th",
                                                    {
                                                      staticClass:
                                                        "atmo-ctc-width-45pct py-1",
                                                    },
                                                    [_vm._v("Описание")]
                                                  ),
                                                  _c(
                                                    "th",
                                                    {
                                                      staticClass:
                                                        "atmo-ctc-width-45pct py-1",
                                                    },
                                                    [
                                                      _vm._v(
                                                        "Причина или цель установки требования"
                                                      ),
                                                    ]
                                                  ),
                                                ]),
                                              ]),
                                              _c(
                                                "tbody",
                                                _vm._l(
                                                  _vm.form.supplier_requirements
                                                    .additional_requirements,
                                                  function (
                                                    requirement,
                                                    index
                                                  ) {
                                                    return _c(
                                                      "tr",
                                                      { key: index },
                                                      [
                                                        _c(
                                                          "td",
                                                          {
                                                            staticClass:
                                                              "atmo-ctc-width-45pct py-1",
                                                          },
                                                          [
                                                            _vm._v(
                                                              _vm._s(
                                                                requirement.description
                                                              )
                                                            ),
                                                          ]
                                                        ),
                                                        _c(
                                                          "td",
                                                          {
                                                            staticClass:
                                                              "atmo-ctc-width-45pct py-1",
                                                          },
                                                          [
                                                            _vm._v(
                                                              _vm._s(
                                                                requirement.reason
                                                              )
                                                            ),
                                                          ]
                                                        ),
                                                      ]
                                                    )
                                                  }
                                                ),
                                                0
                                              ),
                                            ]
                                          ),
                                        ]
                                      ),
                                    ]
                                  ),
                                ]
                              ),
                              _vm.form.delivery_terms.addresses.length > 0 ||
                              _vm.form.delivery_terms.schedule
                                ? [
                                    _c("hr"),
                                    _c(
                                      "h4",
                                      { staticClass: "font-weight-bold" },
                                      [_vm._v("Условия поставки")]
                                    ),
                                    _vm.form.delivery_terms.addresses.length > 0
                                      ? _c(
                                          "b-form-group",
                                          {
                                            staticClass: "mb-0",
                                            attrs: {
                                              "label-cols-sm": 4,
                                              "label-cols-lg": 4,
                                              label:
                                                "Адреса для доставки/самовывоза:",
                                              "label-class":
                                                "fs-14 grey-color fw-700 d-flex align-items-baseline",
                                            },
                                          },
                                          [
                                            _c(
                                              "ul",
                                              _vm._l(
                                                _vm.form.delivery_terms
                                                  .addresses,
                                                function (address, index) {
                                                  return _c(
                                                    "li",
                                                    {
                                                      key: index,
                                                      staticClass:
                                                        "fs-14 grey-color my-auto col-form-label pb-0",
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(
                                                          index +
                                                            1 +
                                                            ". " +
                                                            address.address ??
                                                            address
                                                        )
                                                      ),
                                                    ]
                                                  )
                                                }
                                              ),
                                              0
                                            ),
                                          ]
                                        )
                                      : _vm._e(),
                                    _c("text-row", {
                                      attrs: {
                                        compact: "",
                                        "label-cols-lg": 4,
                                        "label-cols-sm": 4,
                                        label:
                                          "График поставки товаров (выполнения работ, оказания услуг)",
                                        value: _vm.form.delivery_terms.schedule,
                                        "text-wrap": "",
                                      },
                                    }),
                                  ]
                                : _vm._e(),
                              _c("hr"),
                              _c("h4", { staticClass: "font-weight-bold" }, [
                                _vm._v("Спецификация"),
                              ]),
                              _vm.form.deliverables.length > 0
                                ? _c("b-form-group", [
                                    _c(
                                      "ul",
                                      _vm._l(
                                        _vm.form.deliverables,
                                        function (item, index) {
                                          return _c(
                                            "li",
                                            {
                                              key: index,
                                              staticClass:
                                                "fs-14 grey-color my-auto col-form-label py-1",
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(index + 1 + ".") +
                                                  " " +
                                                  _vm._s(item.ktru.name) +
                                                  " - " +
                                                  _vm._s(item.count) +
                                                  ", " +
                                                  _vm._s(item.okei.local_symbol)
                                              ),
                                            ]
                                          )
                                        }
                                      ),
                                      0
                                    ),
                                  ])
                                : _vm._e(),
                              _vm.form.additional_documents.length > 0
                                ? [
                                    _c("hr"),
                                    _c(
                                      "h4",
                                      { staticClass: "font-weight-bold" },
                                      [_vm._v("Дополнительные документы")]
                                    ),
                                    _c("text-row-documents", {
                                      attrs: {
                                        label: "Дополнительные документы",
                                        compact: "",
                                      },
                                      model: {
                                        value: _vm.form.additional_documents,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.form,
                                            "additional_documents",
                                            $$v
                                          )
                                        },
                                        expression: "form.additional_documents",
                                      },
                                    }),
                                  ]
                                : _vm._e(),
                            ],
                            2
                          ),
                          _c(
                            "b-tab",
                            {
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "title",
                                    fn: function () {
                                      return [
                                        _c(
                                          "span",
                                          {
                                            staticClass:
                                              "system_link-style fs-16",
                                          },
                                          [_vm._v("XML")]
                                        ),
                                      ]
                                    },
                                    proxy: true,
                                  },
                                ],
                                null,
                                false,
                                119620390
                              ),
                            },
                            [
                              !_vm.isSignedXml
                                ? _c("b-form-textarea", {
                                    staticClass: "text-monospace fs-12",
                                    attrs: {
                                      disabled: "",
                                      rows: "20",
                                      "no-resize": "",
                                      "no-auto-shrink": "",
                                      wrap: "off",
                                    },
                                    model: {
                                      value: _vm.formXml,
                                      callback: function ($$v) {
                                        _vm.formXml = $$v
                                      },
                                      expression: "formXml",
                                    },
                                  })
                                : _vm._e(),
                              _vm.isSignedXml
                                ? _c("b-form-textarea", {
                                    staticClass: "text-monospace fs-12",
                                    attrs: { disabled: "", rows: "20" },
                                    model: {
                                      value: _vm.signedFormXml,
                                      callback: function ($$v) {
                                        _vm.signedFormXml = $$v
                                      },
                                      expression: "signedFormXml",
                                    },
                                  })
                                : _vm._e(),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "div",
                    {
                      staticClass: "w-100 px-3",
                      attrs: { slot: "modal-footer" },
                      slot: "modal-footer",
                    },
                    [
                      _c("text-row", {
                        attrs: {
                          label: "Сертификат",
                          value: _vm.certificate?.subjectName,
                        },
                      }),
                      _c(
                        "b-button",
                        {
                          staticClass: "mr-2 text-uppercase",
                          attrs: {
                            disabled: _vm.isDataSending,
                            variant: "custom-outline-secondary",
                          },
                          on: { click: _vm.cancelSignModal },
                        },
                        [_vm._v("Отмена")]
                      ),
                      !_vm.isSignedXml
                        ? _c(
                            "b-overlay",
                            {
                              staticClass: "d-inline-block",
                              attrs: {
                                show: _vm.isSigningXml,
                                opacity: "0.6",
                                rounded: "",
                                "spinner-small": "",
                                "spinner-variant": "primary",
                              },
                            },
                            [
                              _c(
                                "b-button",
                                {
                                  staticClass: "text-uppercase",
                                  attrs: {
                                    disabled: !_vm.certificate,
                                    variant: "custom-green",
                                  },
                                  on: { click: _vm.signForm },
                                },
                                [_vm._v("Подписать")]
                              ),
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm.isSignedXml
                        ? _c(
                            "b-overlay",
                            {
                              staticClass: "d-inline-block",
                              attrs: {
                                show: _vm.isDataSending,
                                opacity: "0.6",
                                rounded: "",
                                "spinner-small": "",
                                "spinner-variant": "primary",
                              },
                            },
                            [
                              _c(
                                "b-button",
                                {
                                  staticClass: "text-uppercase",
                                  attrs: {
                                    disabled: !_vm.certificate,
                                    variant: "custom-green",
                                  },
                                  on: { click: _vm.sendData },
                                },
                                [_vm._v("Отправить")]
                              ),
                            ],
                            1
                          )
                        : _vm._e(),
                    ],
                    1
                  ),
                ]
              ),
              _c("span", {
                staticClass: "atmo-hash-jump-point",
                attrs: { id: "atmo-bottom" },
              }),
            ],
            2
          ),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("section", { staticClass: "atmo-fast-access-menu" }, [
      _c("ul", { staticClass: "atmo-container-fixed" }, [
        _c("li", [
          _c("a", { attrs: { href: "#purchase-terms" } }, [
            _vm._v("Условия закупки"),
          ]),
        ]),
        _c("li", [
          _c("a", { attrs: { href: "#supplier-requirements" } }, [
            _vm._v("Требования к участникам закупки"),
          ]),
        ]),
        _c("li", [
          _c("a", { attrs: { href: "#supply-terms" } }, [
            _vm._v("Условия поставки"),
          ]),
        ]),
        _c("li", [
          _c("a", { attrs: { href: "#specification" } }, [
            _vm._v("Спецификация"),
          ]),
        ]),
        _c("li", [
          _c("a", { attrs: { href: "#documents" } }, [_vm._v("Документы")]),
        ]),
        _c("section", { staticClass: "atmo-group" }, [
          _c("li", { attrs: { title: "К верху страницы" } }, [
            _c(
              "a",
              { staticClass: "atmo-button-icon", attrs: { href: "#atmo-top" } },
              [_c("i", { staticClass: "atmo-icon-angle-up" })]
            ),
          ]),
          _c("li", { attrs: { title: "К низу страницы" } }, [
            _c(
              "a",
              {
                staticClass: "atmo-button-icon",
                attrs: { href: "#atmo-bottom" },
              },
              [_c("i", { staticClass: "atmo-icon-angle-down" })]
            ),
          ]),
        ]),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }